import { CommandDeparture } from './types';

export const emptyPredictionTooltip =
  'Estimated from similar empty departures under current marketing; indicative only.';

export function emptyPredictionText(d: CommandDeparture): string | null {
  if (
    d.pax !== 0 ||
    d.pred_pax_source !== 'zero_model' ||
    d.p_sells == null ||
    !Number.isFinite(d.p_sells) ||
    d.p_sells < 0 ||
    d.p_sells > 1
  )
    return null;
  const chance = `Chance of a booking by handback: ${Math.round(d.p_sells * 100)}%`;
  return d.pred_pax_p90 != null && d.pred_pax_p90 >= 1 ? `${chance} · up to ${Math.round(d.pred_pax_p90)} pax` : chance;
}
